export const environment = {
  production: true,
  //recaptcha: {
  //  siteKey: '6LcrWaUsAAAAAALpnhpzfYdVIUzoPpkmgOZ54sCu',
  //},


 /* baseUrl: 'https://localhost:7249/api/'*/
  baseUrl: 'https://nelnetsettlement.azurewebsites.net/api/'
};

